import Cookies from 'js-cookie';
import psl from 'psl';

const TokenKey = 'talecast_token';

export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token) {
  if (process.env.NODE_ENV === 'development') {
    return Cookies.set(TokenKey, token, { expires: 30 });
  } else {
    const parsed = psl.parse(location.host);
    const rootDomain = parsed.domain;
    return Cookies.set(TokenKey, token, { expires: 30, path: '/', domain: `.${rootDomain}` });
  }
}

export function removeToken() {
  Cookies.remove(TokenKey);
  if (process.env.NODE_ENV === 'development') {
    return Cookies.remove(TokenKey);
  } else {
    const parsed = psl.parse(location.host);
    const rootDomain = `.${parsed.domain}`;
    const rootDomain1 = `.${parsed.input}`;
    Cookies.remove(TokenKey, { domain: rootDomain });
    Cookies.remove(TokenKey, { domain: rootDomain1 });
    return;
  }
}

export function CookiesTrackingCode() {
  const trackingCode = Cookies.get('tracking_code');
  if (trackingCode) {
    const parsed = psl.parse(location.host);
    const rootDomain = `.${parsed.domain}`;
    Cookies.remove('tracking_code', { domain: rootDomain });
    return trackingCode;
  }
}
